import React, { useContext } from "react";
import { useCookies } from "react-cookie";
import { Link, navigate } from "gatsby";

import {
    useGlobalLocalization,
    usePageLocalization,
} from "@sbi-international/boutik.gatsby.plugin.multilocale";

import { MagentoCustomerContext } from "@sbi-international/boutik.gatsby.plugin.services";

export default function SiteLocaleSelectionList(props: {
    userStore?: string;
    filterLocal: string;
}) {
    const { filterLocal } = props;
    const [_, setCookies] = useCookies(["century_store"]);
    let {
        localizationContext: { locales },
    } = useGlobalLocalization();
    let { currentPageAlternatives, currentLocale } = usePageLocalization();
    
    const magentoCustomerContext = useContext(MagentoCustomerContext);


    const handleLocaleChange = (
        event: React.MouseEvent<HTMLAnchorElement>,
        to: string,
        langCode: string
    ) => {
        event.preventDefault();

        setCookies("century_store", langCode, { path: "/" });

        window.location.href = to;

        //navigate(to);
    };

    return (
        <ul className="nav">
            {Object.values(locales)
                .filter((l) => (filterLocal == "" ? true : l.localeCode.includes(filterLocal)))
                .map((locale: any) => {
                    let lang = locale.langCode;
                    const currentCountryCode = locale.countryCode;
                    let money = currentCountryCode + "d";

                    const shouldDisplay = locale.localeCode !== currentLocale;

                    if (shouldDisplay) {
                        return (
                            <li className={`locale`} key={locale.localeCode}>
                                <Link
                                    to={currentPageAlternatives[locale.localeCode]}
                                    onClick={(e) =>
                                        handleLocaleChange(
                                            e,
                                            currentPageAlternatives[locale.localeCode],
                                            locale.localeCode
                                        )
                                    }
                                >
                                    {lang.toUpperCase()} | {money.toUpperCase()}
                                </Link>
                            </li>
                        );
                    }
                })}
        </ul>
    );
}
